import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import DesktopSort from './desktop-sort';
import MobileSort from './mobile-sort';
import styles from './styles.module.scss';
const FilterSortWrapper = ({ children }) => (_jsx("div", { className: styles['filter-sort-wrapper'], children: children }));
const FilterSort = React.forwardRef((props, ref) => {
    if (props.isMobile) {
        return (_jsx(FilterSortWrapper, { children: _jsx(MobileSort, { sortKey: props.sortKey, disabled: props.disabled, label: props.label, onSort: props.onSort, toggleShowFilters: props.toggleShowFilters, children: props.children }) }));
    }
    return (_jsx(FilterSortWrapper, { children: _jsx(DesktopSort, { fluidMobile: props.responsiveSelect, selectClasses: props.selectClasses, sortKey: props.sortKey, disabled: props.disabled, label: props.label, onSort: props.onSort, ref: ref, children: props.children }) }));
});
FilterSort.displayName = 'FilterSort';
export default FilterSort;
